import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card-with-content',
  templateUrl: './card-with-content.component.html',
  styleUrls: ['./card-with-content.component.css']
})
export class CardWithContentComponent implements OnInit {

  @Input() cardInfo;
  @Output() public callToAction = new EventEmitter();

  cta;
  
  constructor() { 
    if(this.cardInfo){
      this.cardInfo.array? null :  this.cardInfo.array = [];
    }
  }

  ngOnInit(): void {
  }

  callToActionButton(){
    this.cta = 'buy';
    this.callToAction.emit(this.cta);
  }

  getItemClass(item){
    switch(this.cardInfo.iconSize){
      case 'sm':
        return 'icon-sm';
      case 'md':
        return item.icon + ' icon-med'
      case 'lg':
        return item.icon + ' icon-med'
      default:
        return item.icon + ' icon-sm'
    }
  }

  getTooltip(){
    return 'Contenido premium activado';
  }

}
